export default __webpack_public_path__ + "static/media/left-logo.52b92ee6.png";